import { apiFetch } from "./fetch";

export interface CommunityChannel {
  channel_id: string;
  // creator_id: string;
  // creator_id_sb: string;
  // campaign_id: string;
  // channel_type_name: string;
  name: string;
  // community_guildelines: string;
  // emoji: string;
  // added_at: Date;
  messages_refreshed_at: Date | null;
  // messages_full_refreshed_at: Date | null;
}

export interface User {
  // id: string;
  name: string;
  role: "user" | "campaign" | "admin" | "patreon_admin";
  // image: string;
  // teams: [];
  // banned: boolean;
  // online: boolean;
  // language: "";
  // created_at: string;
  // sb_user_id: string;
  // updated_at: string;
  // last_active: string;
  // patron_data?: {[key: string]: any};
  // sb_operator_id: string;
  // blocked_user_ids: string[];
}

// export interface Reaction {
//   type: string;
//   user: User;
//   score: number;
//   user_id: string;
//   created_at: string;
//   message_id: string;
//   updated_at: string;
// }

export interface MessageData {
  // id: string;
  // cid: string;
  // html: string;
  text: string;
  // type: "regular" | "reply" | "deleted" | "system",
  user: User;
  // pinned: boolean;
  // silent: boolean;
  // shadowed: boolean;
  // pinned_at: string | null;
  // pinned_by: string | null;
  created_at: string;
  // updated_at: string;
  // attachments: [];
  // pin_expires: null;
  // reply_count: number;
  // own_reactions: Reaction[];
  // mentioned_users: User[];
  // reaction_counts: {[emojiId: string]: number};
  // reaction_groups: {
  //   [emojiId: string]: {
  //     count: number;
  //     sum_scores: number;
  //     last_reaction_at: string;
  //     first_reaction_at: string;
  //   };
  // };
  // reaction_scores: {[emojiId: string]: number};
  // latest_reactions: Reaction[];
  // deleted_reply_count: number;
  // thread_participants: User[];
  // restricted_visibility: [];
}

export interface Embed {
  text?: string;
  type: "image" | "video" | "audio" | null; // Sometimes null!
  title: string;
  asset_url?: string; // Only present when type is video or audio.
  image_url: string;
  thumb_url: string;
  title_link?: string;
  // text and title_link shouldn't be undefined, but I guess Patreon has problems with some URLs.
  // author_name?: string; // Not always present, likely per-site difference.
  // og_scrape_url: string;
};

export interface CommunityChannelMessage {
  // channel_id: string;
  message_id: string;
  user_id: string;
  // parent_id: string | null;
  created_at: Date | null;
  // updated_at: Date;
  deleted_at: Date | null;
  // added_at: Date;
  attachments: { path: string; name: string }[];
  embeds: Embed[];
  original_json: MessageData;
  replies?: CommunityChannelMessage[]; // Non-nested, so replies will not have this field.
}

export async function fetchCommunityChannelList(creatorId: string): Promise<CommunityChannel[]> {
  return apiFetch<CommunityChannel[]>(`/patreon/user/${creatorId}/community`);
}

export async function fetchCommunityChannel(creatorId: string, channelId: string): Promise<CommunityChannel> {
  let result = await apiFetch<CommunityChannel>(`/patreon/user/${creatorId}/community/${channelId}`);
  return {
    ...result,
    // added_at: new Date(result.added_at),
    // messages_refreshed_at: result.messages_refreshed_at && new Date(result.messages_refreshed_at),
    // messages_full_refreshed_at: result.messages_full_refreshed_at && new Date(result.messages_full_refreshed_at),
  };
}

export async function fetchCommunityChannelMessages(channelId: string, offset: number): Promise<CommunityChannelMessage[]> {
  let params = new URLSearchParams({ o: offset.toString() });
  let result = await apiFetch<CommunityChannelMessage[]>(`/patreon/user/${channelId}/community/messages`, undefined, params);
  return result.map(message => {
    return {
      ...message,
      created_at: message.created_at && new Date(message.created_at),
      // updated_at: new Date(message.updated_at),
      deleted_at: message.deleted_at && new Date(message.deleted_at),
      // added_at: new Date(message.added_at),
    };
  });
}
